var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBatteryChargingFullFill = function SvgBatteryChargingFullFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "battery_charging_full_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#battery_charging_full_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M15.858 18.132h-1.154a.4.4 0 0 1-.373-.219.4.4 0 0 1 .017-.44l2.001-3.161q.101-.133.247-.094.147.039.146.214v1.931h1.154a.4.4 0 0 1 .373.22.4.4 0 0 1-.017.44l-2.001 3.16q-.101.133-.247.095-.146-.04-.146-.215zm-7.851 2.47a.84.84 0 0 1-.617-.25.84.84 0 0 1-.25-.616V4.928q0-.369.25-.618a.84.84 0 0 1 .617-.249h1.732V3.26q0-.369.25-.617a.84.84 0 0 1 .616-.25h1.806q.369 0 .618.25a.84.84 0 0 1 .249.617v.801h1.734q.368 0 .616.25a.84.84 0 0 1 .248.617v6.107a.57.57 0 0 1-.16.403.73.73 0 0 1-.395.218 5.62 5.62 0 0 0-3.18 1.681 5.8 5.8 0 0 0-1.133 1.743 5.4 5.4 0 0 0-.421 2.14q0 .63.13 1.218.132.588.393 1.134a.74.74 0 0 1-.023.7.6.6 0 0 1-.557.33z"
  }))));
};
export default SvgBatteryChargingFullFill;